import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import RelationshipList from "../RelationshipList";

function AdminRelationship(){
    const[searchUi,setSearchUi]=useState(false)
    return(

        <DataContext.Provider value={{searchUi,setSearchUi}}>
        <Navbar 
         navId={6}
        childrenPage={<RelationshipList/>}/>
        </DataContext.Provider>
    )
}

export default AdminRelationship;